export default {
  paymentManagement: "Payment Option Management",
  newpayment: "Apply New Payment Brand",
  nowUsing: "Using",
  tipsForApplyingWallet:
    "Please log in to the MARS system to apply for additional payment brands.If you do not know your login account, please contact customer support (03-4589-7746).",
  tipsForRmApplyingWallet: "If you would like to add a payment brand, please contact Regional Marketing (011-215-1002)."
};
